<template>
<div id="app">
    <router-view></router-view>
</div>
</template>

<script>
import { startSessionPoll, stopSessionPoll } from '@/sessionGuard'

export default {
    name: 'App',
    beforeMount() {
        this.$store.commit('clearCheckEmoji')
        this.$store.commit('clearMonthList')
    },
    mounted() {
        this.syncSessionPoll()
    },
    beforeDestroy() {
        stopSessionPoll()
    },
    watch: {
        '$store.state.token'() {
            this.syncSessionPoll()
        },
        $route() {
            this.$store.commit('clearCheckEmoji')
            this.$store.commit('clearMonthList')
        },
    },
    methods: {
        syncSessionPoll() {
            if (this.$store.state.token) {
                startSessionPoll()
            } else {
                stopSessionPoll()
            }
        },
    },
}
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Kanit&display=swap");

html,
body,
#app {
    font-family: 'Kanit', sans-serif;
    font-size: 20px;

}

.alert_success {
    margin: 0;
    position: fixed !important;
    z-index: 9999;
    top: 15px;
    right: 5px;
}

.v-text-field input[type="number"] {
  -moz-appearance: textfield;
}
.v-text-field input::-webkit-outer-spin-button,
.v-text-field input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

/* Admin */
/* Team */

.v-data-table>.v-data-table__wrapper>table>thead>tr>th,
.v-data-table>.v-data-table__wrapper>table>tbody>tr>td,
.v-text-field label,
.v-text-field input,
.v-data-footer,
.v-data-footer__select .v-select__selections .v-select__selection--comma,
.v-list-item__title,
.v-btn.v-size--default {
    font-size: 20px !important;
}

.edit_data_teamlist {
    cursor: pointer;
}

.card_role_team>div:first-child {
    width: 30%;

}

.card_role_team>div:last-child {
    width: 70%;
}

.zoftconnect_color {
  background: linear-gradient(to top, #038cc1 , #55c0e9)!important;
}

.title_font_add_team {
    font-size: 22px !important;
}

.title_font_edit_team {
    font-size: 22px !important;
}

.edit_data_rolelist {
    cursor: pointer;
}

.title_font_rolelist {
    font-size: 22px !important;
}

/* Restaurant */
.list_menu_restaurant {
    padding: 15px;
}

.list_menu_restaurant:nth-child(odd) {
    margin-right: 4px;
}

.list_menu_restaurant:nth-child(even) {
    margin-left: 4px;
}

.list_menu_restaurant:hover {
    background: linear-gradient(to top, #038cc1 , #55c0e9)!important;
    transition: 0.1s !important;
}

.list_menu_restaurant:hover>.menu_card_restaurant {
    color: #fff !important;
}

.menu_card_restaurant {
    text-decoration: none;
    color: rgba(0, 0, 0, 0.87) !important;
}

.img_menu_restaurant {
    width: 100px;
}

.img_menu_restaurant>img {
    max-width: 100%;
}

.title_menu_restaurant {
    font-size: 20px;
}

.title_poslist {
    margin-left: 10px;
}

.img_title_poslist {
    width: 50px;
}

.img_title_poslist>img {
    max-width: 100%;
}

.add_table_poslist {
    width: 50px;
}

.add_table_poslist>img {
    max-width: 100%;
}

.list_table_poslist {
    width: 150px;
    margin: auto;
    position: relative;
    cursor: pointer;
}

.list_table_poslist>img {
    max-width: 100%;
}

.title_number_table_poslist {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
}

.title_modal_poslist {
    margin-left: 10px;
}

.img_title_modal_poslist {
    width: 50px;
}

.img_title_modal_poslist>img {
    max-width: 100%;
}

.add_number_table_poslist {
    width: 100%;
    font-size: 25px;
}

.cursor_number_table_icon_poslist {
    cursor: pointer;
}

.money_in_out_img_poslist {
    width: 40px;
    margin-right: 5px;
}

.money_in_out_img_poslist:nth-child(2) {
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
}

.money_in_out_img_poslist>img {
    max-width: 100%;
}

.check_delivery_poslist {
    display: grid;
    grid-template-columns: 50% 50%;
}

.check_delivery_poslist > div:nth-child(odd) {
    padding-right: 5px;
}

.check_delivery_poslist > div:nth-child(even) {
    padding-left: 5px;
}

.w_half_poslist {
    width: 50%;
}

.h_full_poslist {
    height: 100%;
}

.titlefont_poslist {
    font-size: 22px !important;
}

.titlefont_money_inout_poslist {
    font-size: 26px !important;
}

.money_in_out_select_poslist>.v-input__control>.v-input__slot {
    margin-bottom: 0 !important;
}

.money_in_out_detail_poslist:first-child {
    width: 70%;
}

.money_in_out_detail_poslist:last-child {
    width: 30%;
}

.money_in_out_delete_poslist {
    width: 20%;
    text-align: center;
    cursor: pointer;
}

.img_title_pos_table_detail {
    width: 50px;
}

.img_title_pos_table_detail>img {
    max-width: 100%;
}

.title_pos_table_detail {
    margin-left: 10px;
}

.img_table_pos_table_detail {
    width: 100px;
    margin: auto;
    position: relative;
}

.img_table_pos_table_detail>img {
    max-width: 100%;
}

.title_number_table_pos_table_detail {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
}

.button_qrcode_pos_table_detail {
    margin-bottom: 10px;
}

.all_card_select_pos_table_detail {
    height: 100%;
}

.all_card_select_pos_table_detail>div {
    height: 100%;
    width: 30%;
}

.all_card_select_pos_table_detail>div:nth-child(2) {
    margin: 0 15px;
}

.all_card_select_quick_pos_table_detail {
    height: 100%;
}

.all_card_select_quick_pos_table_detail>div {
    height: 100%;
}

.all_card_select_quick_pos_table_detail>div:nth-child(2) {
    margin: 0 15px;
}

.card_select_pos_table_detail {
    height: 100% !important;
}

.number_list_pos_table_detail {
    padding: 15px;
    width: 100%;
}

.img_food_pos_table_detail {
    display: flex;
    justify-content: center;
    height: 150px;
    width: 100%;
    border-radius: 20%;
    overflow: hidden;
    position: relative;
}

.img_food_pos_table_detail>img {
    max-width: 100%;
}

.img_sole_pos_table_detail {
    width: 100px;
    position: absolute;
    top: 0;
    left: 0;
}

.img_sole_pos_table_detail>img {
    max-width: 100%;
}

.add_menu_image_pos_table_detail {
    width: 250px;
    margin: auto;
}

.add_menu_image_pos_table_detail>img {
    max-width: 100%;
}

.check_food_pos_table_detail {
    padding: 0 !important;
    margin: 0 !important;
}

.cursor_icon_pos_table_detail {
    cursor: pointer;
}

.header_check_food_pos_table_detail {
    padding: 0 !important;
    height: 80px;
    overflow: hidden;
    border-bottom: rgba(0, 0, 0, 0.87) 1px solid;
}

.header_check_food_not_pos_table_detail {
    padding: 0 !important;
    height: 50px;
}

.detail_check_food_pos_table_detail {
    width: 100%;
}

.title_check_food_pos_table_detail {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    width: 50%;
}

.grad-primary-bg {
    background: linear-gradient(to top, #038cc1 , #55c0e9);
}

.title_check_food_pos_table_detail:first-child {
    border-right: rgba(0, 0, 0, 0.87) 1px solid;
}

.title_check_food_pos_table_detail:last-child {
    border-left: rgba(0, 0, 0, 0.87) 1px solid;
}

.color_green_pos_table_detail {
    background: #2e8b57;
}

.color_yellow_pos_table_detail {
    background: linear-gradient(to top, #158cba, #55c0e9);
}

.color_disabled_pos_table_detail{
    background-color: rgba(0, 0, 0, 0.12); 
    color: rgba(0, 0, 0, 0.26);
}

.list_food_pos_table_detail {
    cursor: pointer;
}

.w_half_pos_table_detail {
    width: 50%;
}

.w_full_pos_table_detail {
    width: 100%;
}

.titlefont_pos_table_detail {
    font-size: 22px !important;
}

.color_font_pos_table_detail {
    border: 1px #fb8c00 solid;
    background: #fb8c00;
    color: #ffffff !important;
}

.color_font_pos_table_detail>.v-expansion-panel-header__icon>i {
    color: #ffffff !important;
}

.header_panel_pos_table_detail.v-expansion-panel::before {
    box-shadow: unset !important;
    -webkit-box-shadow: unset !important;
}

.color_font_history_pos_table_detail {
    border: 1px #038cc1 solid;
    background: #038cc1;
    color: #ffffff !important;
}

.color_font_history_pos_table_detail>.v-expansion-panel-header__icon>i {
    color: #ffffff !important;
}

.color_font_history_takehome_pos_table_detail {
    border: 1px #2e8b57 solid;
    background: #2e8b57;
    color: #ffffff !important;
}

.color_font_history_takehome_pos_table_detail>.v-expansion-panel-header__icon>i {
    color: #ffffff !important;
}

.header_panel_pos_table_detail,
.color_font_pos_table_detail,
.color_font_history_pos_table_detail,
.color_font_history_takehome_pos_table_detail {
    font-size: 20px !important;
}

.body_food_pos_table_detail>.v-expansion-panel-content__wrap {
    padding: 0 !important;
}

.amount_food_pos_table_detail {
    background: #fff;
}

.send_food_pos_table_detail {
    cursor: pointer;
    font-size: 20px;
}

.qr_code_pos_table_detail {
    text-align: center;
}

.qr_code_pos_table_detail>img {
    max-width: 100%;
}

.topping_food_pos_table_detail {
    font-size: 16px;
}

.topping_out_pos_table_detail {
    color: #ff5252;
}

.description_detail_pos_table_detail {
    color: #696969;
}

.out_of_stock_pos_table_detail {
    color: #ff5252;
}

.font_amount_topping_pos_table_detail {
    font-size: 18px;
}

/* .amount_list_topping_pos_table_detail{
     color: #ff5252;
} */

.add_note_pos_table_detail>.v-expansion-panel::before {
    -webkit-box-shadow: unset;
    box-shadow: unset;
}

.add_note_pos_table_detail>.v-expansion-panel>.v-expansion-panel-header {
    padding: 0;
    width: auto;
}

.add_note_pos_table_detail>.v-expansion-panel>.v-expansion-panel-content>.v-expansion-panel-content__wrap {
    padding: 0 0 16px;
    color: #696969;
}

.note_pos_table_detail {
    color: #ff5252;
}

.food_table_pos_table_detail {
    padding: 15px;
    background: #038cc1;
    border-radius: 20px;
}

.food_table_takehome_pos_table_detail {
    padding: 15px;
    background: #2e8b57;
    border-radius: 20px;
}

.food_takehome_pos_table_detail {
    padding: 15px;
    background: #2f4f4f;
    border-radius: 20px;
}

.food_cart_pos_table_detail {
    padding: 15px;
    background: #fb8c00;
    border-radius: 20px;
}

.detail_table_pos_table_detail {
    width: 10%;
}

.page_edit_table_pos_table_detail {
    cursor: pointer;
}

.link_nametakeoutuser_takeout_admin {
    text-decoration: none;
}

.title_takeout_admin {
    margin-left: 10px;
}

.img_title_takeout_admin {
    width: 50px;
}

.img_title_takeout_admin>img {
    max-width: 100%;
}

.detail_food_yellow_takeout_admin {
    border: 1px #fb8c00 solid;
    cursor: pointer;
}

.font_food_yellow_takeout_admin {
    color: #fb8c00;
}

.detail_food_green_takeout_admin {
    border: 1px #4caf50 solid;
}

.font_food_green_takeout_admin {
    color: #4caf50;
}

.detail_food_red_takeout_admin {
    border: 1px #ff5252 solid;
}

.font_food_red_takeout_admin {
    color: #ff5252;
}

.title_bill_retrospect {
    margin-left: 10px;
}

.titlefont_bill_retrospect {
    font-size: 22px !important;
}

.img_title_bill_retrospect {
    width: 50px;
}

.img_title_bill_retrospect>img {
    max-width: 100%;
}

.detail_bill_retrospect {
    cursor: pointer;
}

.report_bill_retrospect {
    border: #000 1px solid;
    padding: 10px;
    font-size: 14px;
    margin-bottom: 10px;
}

.header_report_bill_retrospect {
    font-size: 12px;
}

.img_report_bill_retrospect {
    width: 100px;
}

.img_report_bill_retrospect>img {
    max-width: 100%;
}

.cursor_bill_retrospect {
    cursor: pointer;
}

.title_bill_retrospect_all {
    margin-left: 10px;
}

.titlefont_bill_retrospect_all {
    font-size: 22px !important;
}

.img_title_bill_retrospect_all {
    width: 50px;
}

.img_title_bill_retrospect_all>img {
    max-width: 100%;
}

.detail_bill_retrospect_all {
    cursor: pointer;
}

.report_bill_retrospect_all {
    border: #000 1px solid;
    padding: 10px;
    font-size: 14px;
    margin-bottom: 10px;
}

.header_report_bill_retrospect_all {
    font-size: 12px;
}

.img_report_bill_retrospect_all {
    width: 100px;
}

.img_report_bill_retrospect_all>img {
    max-width: 100%;
}

.cursor_bill_retrospect_all {
    cursor: pointer;
}

.img_title_paymentfood {
    width: 50px;
    margin: 0 10px;
}

.img_title_paymentfood>img {
    max-width: 100%;
}

.report_paymentfood {
    border: #000 1px solid;
    padding: 10px;
    font-size: 14px;
    margin-bottom: 10px;
}

.header_report_paymentfood {
    font-size: 12px;
}

.img_report_paymentfood {
    width: 90px;
    margin-right: 5px;
}

.img_report_paymentfood>img {
    max-width: 100%;
}

.cursor_order_list_paymentfood {
    cursor: pointer;
}

.payment_amount_payment_food {
    padding: 15px;
}

.payment_amount_payment_food>div {
    font-size: 30px;
}

.preview_change_money_payment_food {
    font-size: 50px !important;
}

.receive_payment_food {
    width: 50%;
    font-size: 30px;
}

.calculate_payment_food {
    flex-grow: 1;
    padding: 0 5px;
}

.optioncalculate_payment_food {
    flex-grow: 1;
    padding: 0 5px;
}

.button_calculate_payment_food>div {
    border: #038cc1 5px solid;
    padding: 15px;
    width: 100%;
    border-radius: 30%;
    font-size: 35px;
    text-align: center;
    cursor: pointer;
    color: #038cc1;
}

.button_calculate_payment_food>div:nth-child(2) {
    margin: 0 10px;
}

.button_optioncalculate_payment_food {
    border: #038cc1 5px solid;
    padding: 15px;
    width: 100%;
    border-radius: 30%;
    font-size: 35px;
    text-align: center;
    height: 50%;
    cursor: pointer;
}

.button_optioncalculate_payment_food>div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: #038cc1;
}

.button_optioncalculate_payment_food>div>i {
    color: #038cc1 !important;
}

.title_font_payment_food {
    font-size: 22px !important;
}

.change_payment_food {
    font-size: 40px !important;
}

.card_payment_result_payment_food {
    width: 50%;
}

.report_payment_takeout_admin {
    border: #000 1px solid;
    padding: 10px;
    font-size: 14px;
    margin-bottom: 10px;
}

.header_report_payment_takeout_admin {
    font-size: 12px;
}

.img_report_payment_takeout_admin {
    width: 100px;
}

.img_report_payment_takeout_admin>img {
    max-width: 100%;
}

.payment_amount_payment_takeout_admin {
    padding: 15px;
}

.payment_amount_payment_takeout_admin>div {
    font-size: 30px;
}

.receive_payment_takeout_admin {
    width: 50%;
    font-size: 30px;
}

.calculate_payment_takeout_admin {
    flex-grow: 1;
    padding: 0 5px;
}

.optioncalculate_payment_takeout_admin {
    flex-grow: 1;
    padding: 0 5px;
}

.button_calculate_payment_takeout_admin>div {
    border: #fdbd10 5px solid;
    padding: 15px;
    width: 100%;
    border-radius: 30%;
    font-size: 35px;
    text-align: center;
    cursor: pointer;
    color: #fdbd10;
}

.button_calculate_payment_takeout_admin>div:nth-child(2) {
    margin: 0 10px;
}

.button_optioncalculate_payment_takeout_admin {
    border: #fdbd10 5px solid;
    padding: 15px;
    width: 100%;
    border-radius: 30%;
    font-size: 35px;
    text-align: center;
    height: 50%;
    cursor: pointer;
}

.button_optioncalculate_payment_takeout_admin>div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: #fdbd10;
}

.button_optioncalculate_payment_takeout_admin>div>i {
    color: #fdbd10 !important;
}

.title_font_payment_takeout_admin {
    font-size: 22px !important;
}

.change_payment_takeout_admin {
    font-size: 40px !important;
}

.cursor_order_list_payment_takeout_admin {
    cursor: pointer;
}

.card_payment_result_payment_takeout_admin {
    width: 50%;
}

.header_sale_report_day {
    margin-left: 10px;
}

.img_header_sale_report_day {
    width: 50px;
}

.img_header_sale_report_day>img {
    max-width: 100%;
}

.title_sale_report_day>div {
    width: 50%;
    text-align: center;
}

.print_sale_report_day>div {
    width: 50%;
}

.img_link_statistic_sale_report_day {
    width: 50px;
}

.img_link_statistic_sale_report_day>img {
    max-width: 100%;
}

.border_sale_report_day {
    color: #038cc1 !important;
    border: 1px #038cc1 solid !important;
}

.titlefont_sale_report_day {
    font-size: 32px !important;
}

.header_sale_statistic {
    margin-left: 10px;
}

.img_title_sale_statistic {
    width: 50px;
}

.img_title_sale_statistic>img {
    max-width: 100%;
}

.startdate_sale_statistic,
.enddate_sale_statistic {
    width: 50%;
}

.card_menu_header_sale_statistic>div {
    width: 50%;
}

.title_manage_food {
    margin-left: 10px;
}

.img_title_manage_food {
    width: 50px;
}

.img_title_manage_food>img {
    max-width: 100%;
}

.card_menu_header_manage_food>div {
    width: 50%;
}

.size_title_manage_food {
    font-size: 22px !important;
}

.title_addfood_manage_food {
    margin-left: 10px;
}

.img_title_addfood_manage_food {
    width: 50px;
}

.img_title_addfood_manage_food>img {
    max-width: 100%;
}

.check_type_full_addfood_manage_food {
    width: 100%;
}

.check_type_addfood_manage_food {
    width: 50%;
}

.titlefont_addfood_manage_food {
    font-size: 22px !important;
}

.h_full_addfood_manage_food {
    height: 100%;
}

.choose_more_addfood_manage_food {
    color: #565656;
    font-size: 18px;
}

.title_addtopping_manage_food {
    margin-left: 10px;
}

.img_title_addtopping_manage_food {
    width: 50px;
}

.img_title_addtopping_manage_food>img {
    max-width: 100%;
}

.check_type_addtopping_manage_food {
    width: 50%;
    font-size: 20px;
}

.cursor_addtopping_manage_food {
    cursor: pointer;
}

.border_choice_addtopping_manage_food {
    border-right: #000000 1px solid;
    padding-right: 5px;
    margin-right: 5px;
}

.titlefont_addtopping_manage_food {
    font-size: 22px !important;
}

.title_buffet_manage {
    margin-left: 10px;
}

.img_title_buffet_manage {
    width: 50px;
}

.img_title_buffet_manage>img {
    max-width: 100%;
}

.card_buffet_manage>div:first-child {
    width: 30%;

}

.card_buffet_manage>div:last-child {
    width: 70%;
}

.titlefont_buffet_manage {
    font-size: 22px !important;
}

.edit_data_buffet_manage {
    cursor: pointer;
}

.header_sale_report {
    margin-left: 10px;
}

.img_header_sale_report {
    width: 50px;
}

.img_header_sale_report>img {
    max-width: 100%;
}

.print_sale_report>div {
    width: 50%;
}

.img_link_statistic_sale_report {
    width: 50px;
}

.img_link_statistic_sale_report>img {
    max-width: 100%;
}

.startdate_sale_report,
.enddate_sale_report {
    width: 50%;
}

.border_sale_report {
    color: #038cc1 !important;
    border: 1px #038cc1 solid !important;
}

.titlefont_sale_report {
    font-size: 32px !important;
}

.title_order_list {
    margin-left: 10px;
}

.img_title_order_list {
    width: 50px;
}

.img_title_order_list>img {
    max-width: 100%;
}

.food_table_order_list {
    padding: 15px;
    background: #4caf50;
    border-radius: 20px;
}

.food_table_takehome_order_list {
    padding: 15px;
    background: #2e8b57;
    border-radius: 20px;
}

.food_takehome_order_list {
    padding: 15px;
    background: #2f4f4f;
    border-radius: 20px;
}

.food_cart_order_list {
    padding: 15px;
    background: #fb8c00;
    border-radius: 20px;
}

.detail_food_green_order_list {
    border: 1px rgba(0, 0, 0, 0.87) solid;
}

.header_panel_order_list.v-expansion-panel::before {
    box-shadow: unset !important;
    -webkit-box-shadow: unset !important;
}

.color_font_history_order_list {
    border: 1px #4caf50 solid;
    background: #4caf50;
    color: #ffffff !important;
}

.color_font_history_order_list>.v-expansion-panel-header__icon>i {
    color: #ffffff !important;
}

.color_font_table_takehome_history_order_list {
    border: 1px #2e8b57 solid;
    background: #2e8b57;
    color: #ffffff !important;
}

.color_font_table_takehome_history_order_list>.v-expansion-panel-header__icon>i {
    color: #ffffff !important;
}

.color_font_takehome_history_order_list {
    border: 1px #2f4f4f solid;
    background: #2f4f4f;
    color: #ffffff !important;
}

.color_font_takehome_history_order_list>.v-expansion-panel-header__icon>i {
    color: #ffffff !important;
}

.header_panel_order_list,
.color_font_history_order_list,
.color_font_table_takehome_history_order_list,
.color_font_takehome_history_order_list {
    font-size: 20px !important;
}

.body_food_order_list>.v-expansion-panel-content__wrap {
    padding: 0 !important;
}

.amount_food_order_list {
    background: #fff;
}

.topping_food_order_list {
    font-size: 16px;
}

.note_order_list {
    color: #ff5252;
}

.print_order_list {
    cursor: pointer;
}

.print_order_list>i {
    color: #ffffff !important;
}

/* .amount_list_topping_order_list{
    color: #ff5252;
} */

.title_advertis {
    margin-left: 10px;
}

.img_title_advertis {
    width: 50px;
}

.img_title_advertis>img {
    max-width: 100%;
}

.size_title_advertis {
    font-size: 22px !important;
}

.card_advertise>div:first-child {
    width: 30%;

}

.card_advertise>div:last-child {
    width: 70%;
}

.titlefont_advertise {
    font-size: 22px !important;
}

.img_title_summary_bf_cs {
    width: 50px;
}

.img_title_summary_bf_cs>img {
    max-width: 100%;
}

.title_summary_bf_cs {
    margin-left: 10px;
}

.size_title_summary_bf_cs {
    font-size: 22px !important;
}

.border_sale_summary_bf_cs {
    color: #038cc1 !important;
    border: 1px #038cc1 solid !important;
}

.titlefont_summary_bf_cs {
    font-size: 32px !important;
}

.half_summary_bf_cs {
    width: 50%;
}

.full_summary_bf_cs {
    width: 100%;
}

/* Stock */
.list_menu_stock {
    padding: 15px;
}

.list_menu_stock:nth-child(odd) {
    margin-right: 4px;
}

.list_menu_stock:nth-child(even) {
    margin-left: 4px;
}

.list_menu_stock:hover {
    background: linear-gradient(to top, #038cc1 , #55c0e9)!important;
    transition: 0.1s !important;
}

.list_menu_stock:hover>.menu_card_stock {
    color: #fff !important;
}

.list_menu_stock_none {
    width: 50%;
    padding: 15px;
    margin-left: 5px;
}

.menu_card_stock {
    text-decoration: none;
    color: rgba(0, 0, 0, 0.87) !important;
}

.img_menu_stock {
    width: 100px;
}

.img_menu_stock>img {
    max-width: 100%;
}

.title_menu_stock {
    font-size: 20px;
}

.font_add_food{
    font-size: 13px;
}
</style>
